import React, { useContext } from "react";

import ReadOnlyField from "./read-only-field";

import { AttributesContext } from "../../../contexts/attributes";
import { checkUpdate } from "../lib/attribute-data";

const ReferenceField = ({ attribute, isCompleted, readOnlyOverride, value, upc, wipKey }) => {
    const attributes = useContext(AttributesContext);

    const updateAttribute = (v) => {
        const hasUpdate = checkUpdate(attributes.data[attribute.uuid], v, attribute.componentType);

        if (!hasUpdate || !v) {
            return;
        }

        const valueToSave = typeof v === "string" ? v.trim() : v;

        if (attributes.data.hasOwnProperty(attribute.uuid)) {
            attributes.update(attribute, valueToSave, true);
        } else {
            attributes.add(attribute, valueToSave, true);
        }
    };

    return (
        <ReadOnlyField
            upc={upc}
            id={attribute.uuid}
            value={value}
            attribute={attribute}
            updateAttribute={updateAttribute}
            readOnlyOverride={readOnlyOverride}
            isCompleted={isCompleted}
            wipKey={wipKey}
        />
    );
};

export default ReferenceField;
